module.exports = __webpack_public_path__ + "static/media/aboutUs_27_27.eb12ac23.jpg";